<template>
  <div v-if="branch">
    <!-- title -->
    <p class="title is-4 is-spaced">{{ branch.branch }}</p>

    <!-- tabs -->
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'branch-general' }" active-class="is-active" tag="li" exact><a>{{"branch.tabs.general" | translate}}</a></router-link>
        <router-link :to="{ name: 'branch-pages-list' }" active-class="is-active" tag="li"><a>{{"branch.tabs.pages" | translate}}</a></router-link>
      </ul>
    </div>

    <!-- router view -->
    <router-view />
  </div>
</template>
<script>
  import branchService from "../../../../services/branch.service"
  import breadcrumbsService from "../../../../services/breadcrumbs.service"

  export default {
    name: 'client-branch',
    data() {
      return {
        branch: null
      }
    },
    computed: {
      branchName() {
        return this.$route.params.branch;
      }
    },
    async mounted() {
      await this.loadBranch();
      breadcrumbsService.dynamic.set({ key: "branch", func: () => this.branch.branch });
    },
    methods: {
      async loadBranch() {
        this.branch = await branchService.get(this.branchName);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/branches/branch/index.vue